// column chart
import ReactApexChart from 'react-apexcharts';

const ColumnChart = ({ group, data, xaxis, titleText, horizontal, status ,series}) => {
	const colors = ['#41B883', '#afafaf', '#57a850'];
	// const deficitOf100= data.map(value=> 100 - value);
	const state = {
		series:!!series?[
			{
				"name": "SE",
				"data": [
					0,
					0
				]
			},
			{
				"name": "NC",
				"data": [
					1,
					3
				]
			},
			{
				"name": "NW",
				"data": [
					0,
					0
				]
			},
			{
				"name": "NE",
				"data": [
					0,
					0
				]
			}
		] : [
			{	
				name: 'Current Progress',
				data: data,
				//color: '#41B883',
			},
			// {	
			// 	name: 'Target Deficit',
			// 	data: deficitOf100,
			// 	//color: '#00D8FF',
			// },
		],
		options: {
			chart: {
				height: 350,
				width: '100%',
				type: 'bar',
				stacked: true,
				stackType: '100%',
				events: {
					click: function (chart, w, e) {
						// console.log(chart, w, e)
					},
				},
			},
			colors: colors,
			plotOptions: {
				bar: {
					columnWidth: '45%',
					distributed: false,
					horizontal,
				},
			},
			stroke: {
				width: 1,
				colors: ['#fff'],
			},
			dataLabels: {
				enabled: true,
			},
			legend: {
				show: false,
			},
			xaxis: {
				categories: xaxis,
				colors: ['#fff', '#afafaf', '#afafaf'],
				labels: {
					style: {
						//colors: colors,
						fontSize: '12px',
					},
				},
			},
			title: {
				text: titleText,
				floating: true,
				style: {
					color: 'navy',
				}
			},
		},
	};

	return (
		<div>
			<ReactApexChart options={state.options} series={state.series} type="bar" height={380} />
		</div>
	);
};

export default ColumnChart;